import React, { useState, useEffect } from 'react';
import { useSaleSoModel } from "../saleSoModel";
import { YhPrint } from "@/components/YhPrint";
import { saleSoService } from '../saleSoService';
import { IDetailList, ISaleSoDetail } from '../saleSoTypes';
import { formatNum, formatIntPoint, numberParseChina } from '@/utils/utils';
import moment from 'moment';
import { useDictModel } from '@/views/base/dict/dictModel';
import { YhPrintSa } from "@/components/YHPrintSa";
export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export function Print() {
    const initDesc = { total: 0, discount: 0 }
    const { print, setPrint, onPrinting, selectedRow } = useSaleSoModel();
    const [formVal, setFormVal] = useState<ISaleSoDetail>();
    const [goodsList, setGoodsList] = useState<IDetailList[]>([]);
    const { getTreeNodeOne } = useDictModel();
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);

    useEffect(() => {
        print && getPoDetailOne()
    }, [print])

    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleSoService.one(selectedRow.saleCode as string);
        let { details, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }

        // let newDetails = details?.map((item)=>()
        let newDetails = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price);
            newMaintenanceTotal.discount = item.discountRate as number;

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price)
            }
        })
        if (retData) {
            setGoodsList(newDetails as IDetailList[] ?? [])
            setMaintenanceTotal(newMaintenanceTotal)
            setFormVal(formVal)
        }
    };

    const columns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            title: 'PART NO رقم القطع',
            dataIndex: 'materialCode',
        },
        {
            title: 'Description أسم القطع ',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'Quantity كيمة  ',
            dataIndex: 'num',
        },
        {
            title: 'Unit price SR أسعار ',
            dataIndex: 'price',
        },
        {
            title: ' Amount أجمالي ',
            dataIndex: 'notAmount',
        }
    ]
    //商品
    const columsAlb = [
        // {
        //     title: 'الاجمالي بعد الضريبة',
        //     dataIndex: 'total',
        //     // render:(text:any)=>''
        // },
        // {
        //     title: 'قيمة الضريبة',
        //     dataIndex: 'tax',
        //     // render:(text:any)=>''
        // },
        {
            title: 'الاجمالي',
            dataIndex: 'notAmount',
        },
        {
            title: 'سعر الوحدة',
            dataIndex: 'price',
        },
        {
            title: 'الكمية',
            dataIndex: 'num',
        },
        {
            title: 'الوحدة',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'اسم الصنف',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'رقم الصنف',
            dataIndex: 'materialCode',
        },
    ]
    const columsEn = [
        // {
        //     title: 'Total amount With',
        //     dataIndex: 'notAmount',
        //     render: (text: any, record: any) => formatNum(Number(text) * 1.15)
        // },
        // {
        //     title: 'Vat Amount',
        //     dataIndex: 'notAmount',
        //     render: (text: any, record: any) => formatNum(Number(text) * 0.15)
        // },
        {
            title: 'Subtotal',
            dataIndex: 'notAmount',
        },
        {
            title: 'Unit Price',
            dataIndex: 'price',
        },
        {
            title: 'Quantity',
            dataIndex: 'num',
        },
        {
            title: 'Unit',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'Item',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'Item Code',
            dataIndex: 'materialCode',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "Date:",
                fieldValue: moment(formVal?.createTime).format("YYYY/MM/DD"),
                fieldLabelAlb: 'التاريخ:'
            },
            {
                fieldLabel: "Customer Name:",
                fieldValue: formVal?.customerName,
                fieldLabelAlb: 'اسم العميل'
            },
            {
                fieldLabel: "Type:",
                fieldValue: getTreeNodeOne(formVal?.payType as string)[0]?.nameEn as string ?? '',
                fieldLabelAlb: 'نوع الفاتوره:'
            },
            {
                fieldLabel: "Invoice No:",
                fieldValue: `NOR${formVal?.saleCode?.slice(5)}`,
                fieldLabelAlb: 'رقم الفاتورة'
            },
            {
                fieldLabel: "Customer Vat No:",
                fieldValue: '',
                fieldLabelAlb: 'الرقم الضريبي للعميل',
                className: " border-bootom"
            },
        ],
        footer: [
            {
                fieldLabel: "Prepared اعداد",
                fieldValue: ""
            },
            {
                fieldLabel: "Customer العميل",
                fieldValue: ""
            },
        ],
        totalAmount: [
            // {
            //     fieldLabel: "SUBTOTAL اجمالي",
            //     // fieldValue: formVal?.discountTotalAmount/(100 - Number(formVal?.discountRate),/ ((100 - Number(formVal?.discountRate) / 100)
            //     fieldValue: Number(formVal?.discountTotalAmount) / (100 - Number(formVal?.discountRate)) * 100
            // },
            // {
            //     // fieldLabel: (100 - Number(formVal?.discountRate)) + "%",
            //     fieldLabel: (100 - Number(formVal?.discountRate)) + "% الخصم",
            //     // fieldValue: (Number(formVal?.receivedAmount) + Number(formVal?.favorableAmount)) / Number(formVal?.totalAmount) * 100,
            //     // fieldValue: Number(formVal?.totalAmount) - Number(formVal?.totalAmount) * Number(formVal?.discountRate) / 100,
            //     fieldValue: formVal?.discountTotalAmount,
            //     // suffix: "%"
            // },
            // {
            //     fieldLabel: "TOTAL اجمالي",
            //     // fieldValue: +formatNum(Number(formVal?.totalAmount) - Number(formVal?.discountTotalAmount)),
            //     fieldValue: formVal?.totalAmount
            // },
            // {
            //     fieldLabel: "VAT 15% الضريبة",
            //     // fieldValue: (Number(formVal?.totalAmount) - Number(formVal?.discountTotalAmount)) * 0.15,formatNum
            //     fieldValue: +formatNum(Number(formVal?.totalAmount)) * 0.15,
            // },
            // {
            //     fieldLabel: " NET TOTAL الصافي",
            //     // fieldValue: (Number(formVal?.receivedAmount) *1.15).toFixed(2)
            //     fieldValue: formVal?.receivedAmount,
            // },
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true,
                className: 'bd-none',
            },
            {
                fieldLabel: "Subtotal",
                fieldValue: maintenanceTotal.total,
                fieldLabelAlb: "الاجمالي",
                className: 'bd-none',

            },
            {
                fieldLabel: "Discount %",
                fieldValue: maintenanceTotal.discount === 100 ? 0 : (100 - maintenanceTotal.discount),
                suffix: "%",
                fieldLabelAlb: "نسبة الخصم",
                className: 'bd-none',

            },
            {
                fieldLabel: "Discount Amount",
                fieldValue: formatNum(formVal?.discountTotalAmount),
                fieldLabelAlb: "الخصم",
                className: 'bd-none',
            },
            {
                fieldLabel: "Net Total",
                fieldValue: formVal?.totalAmount,
                fieldLabelAlb: "الصافي",
                className: 'bd-none',
            },
            {
                fieldLabel: "Vat Amount 15 %",
                fieldValue: +formatNum(Number(formVal?.totalAmount)) * 0.15,
                fieldLabelAlb: "الضريبة 15%",
                className: 'bd-none',
            },
            {
                fieldLabel: "Total With Vat",
                fieldValue: formVal?.receivedAmount,
                fieldLabelAlb: "الصافي بعد الضريبة",
                className: 'bd-none',
            },
        ]
    }
    const onCancel = () => {
        setPrint(false)
        setGoodsList([]);
        setFormVal({})
    }
    const onConfirm = async () => {
        let { id, saleCode } = selectedRow
        await onPrinting({ id, saleCode })
    }
    return (
        <YhPrintSa
            title=""
            type=""
            pageHeader="Sales Invoice فاتورة مبيعات "
            visible={print}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            dataSource={goodsList}
            printShow={printShow}
            columsAlb={columsAlb}
            columsEn={columsEn}
            formVal={`رقم الضريبة:301198769900003 شركة نور السيارات المحدودة
            تاريخ：${ moment(formVal?.createTime).format("DD/MM/YYYY HH:MM")}
            ضريبة القيمة المضافة：${+formatNum(Number(formVal?.totalAmount)) * 0.15}
            الإجمالي شاملاً ضريبة القيمة المضافة：${formatNum(Number(formVal?.receivedAmount))}`}
        />
    );
}

export default Print;
